import { useEffect, useState } from "react";
import type { NextPage } from "next";
import { useTranslation } from "next-i18next/pages";
import { useInView } from "react-intersection-observer";
import Navigation from "components/common/Navigation";
import Seo from "components/common/Seo";
import Header from "components/home/Header";
import LogoStrip from "components/home/LogoStrip";
import PainPoints from "components/home/PainPoints";
import SolutionOverview from "components/home/SolutionOverview";
import CaseStudyHighlight from "components/home/CaseStudyHighlight";
import Compliance from "components/home/Compliance";
import Trustedby from "components/home/Trustedby";
import Testimonial from "components/home/Testimonial";
import FAQ from "components/home/FAQ";
import Footer from "components/common/Footer";
import {
  CMS_REVALIDATE_SECONDS,
  serverSideCmsTranslations
} from "lib/cms/translations";
import styles from "../styles/home/Home.module.css";

export async function getStaticProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideCmsTranslations(locale, ["common"]))
    },
    revalidate: CMS_REVALIDATE_SECONDS
  };
}

const Home: NextPage = () => {
  const { t } = useTranslation("common");
  const [isDarkColor, setIsDarkColor] = useState<boolean>(false);
  const { ref, inView } = useInView({ rootMargin: "0% 0% -100%" });

  useEffect(() => {
    if (inView) {
      setIsDarkColor(true);
    } else {
      setIsDarkColor(false);
    }
  }, [inView]);

  return (
    <>
      <Seo
        title={t("global.websiteTitle")}
        description={t("global.websiteDescription")}
        path="/"
      />

      <Navigation isDarkColor={isDarkColor} doAnimation />
      <main id="main-content">
        <Header />

        <LogoStrip />

        <div className={styles.mainContainer} ref={ref}>
          <PainPoints />
          <SolutionOverview />
          <CaseStudyHighlight />
          <Compliance />
          <Trustedby />
          <Testimonial doAnimation />
          <FAQ />
        </div>
      </main>
      <Footer doAnimation />
    </>
  );
};

export default Home;
